export const SET_CREATE_ANNOUNCEMENT = 'SET_CREATE_ANNOUNCEMENT'
export const SEARCH_ANNOUNCEMENT = 'SEARCH_ANNOUNCEMENT'
export const SET_ANNOUNCEMENT_SEARCH_CRITERIA = 'SET_ANNOUNCEMENT_SEARCH_CRITERIA'
export const SET_ANNOUNCEMENT_DETAILS = 'SET_ANNOUNCEMENT_DETAILS'
export const UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT'
export const DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT'
